import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import { IMG, PRICE, Reveal } from './shared';
import { trackEvent } from '../../lib/analytics';

const LuminexHero = ({ onBuy }) => {
  useEffect(() => { trackEvent('homepage_luminex_view'); }, []);
  return (
    <section className="relative min-h-screen bg-[#0a0a0a] text-white overflow-hidden flex flex-col" data-testid="hv2-hero">
      <div className="absolute inset-0 hv2-noise" aria-hidden="true" />
      <div className="relative flex-1 max-w-7xl mx-auto w-full px-6 md:px-12 grid lg:grid-cols-2 items-center gap-8 pt-28 pb-10">
        <div className="order-2 lg:order-1">
          <Reveal>
            <p className="font-manrope text-xs md:text-sm uppercase tracking-[0.35em] font-bold text-white/50 mb-6">Harpalyk</p>
          </Reveal>
          <Reveal delay={100}>
            <h1 className="font-outfit text-6xl md:text-7xl lg:text-8xl font-medium leading-none tracking-tighter">LumineX 300</h1>
          </Reveal>
          <Reveal delay={200}>
            <p className="font-outfit text-2xl md:text-3xl text-white/80 mt-5 tracking-tight">Cleaning, Reinvented.</p>
          </Reveal>
          <Reveal delay={300}>
            <p className="font-manrope text-base md:text-lg text-white/50 mt-5 max-w-md leading-relaxed">
              15,000Pa power. LiDAR + AI intelligence. Hands-free cleaning.
            </p>
          </Reveal>
          <Reveal delay={400}>
            <p className="font-oswald text-3xl md:text-4xl font-medium mt-8 text-white" data-testid="hv2-hero-price">{PRICE}</p>
          </Reveal>
          <Reveal delay={500}>
            <div className="flex flex-wrap items-center gap-4 mt-8">
              <Link
                to="/products/luminex-300"
                onClick={() => trackEvent('homepage_luminex_explore')}
                data-testid="hv2-hero-explore-btn"
                className="font-manrope bg-[#0057B8] hover:bg-[#004494] text-white px-8 py-4 rounded-full font-semibold transition-colors"
              >
                Explore LumineX 300
              </Link>
              <button
                onClick={onBuy}
                data-testid="hv2-hero-buy-btn"
                className="font-manrope border border-white/25 hover:bg-white hover:text-black text-white px-8 py-4 rounded-full font-semibold transition-colors"
              >
                Buy Now
              </button>
            </div>
          </Reveal>
        </div>
        <Reveal delay={200} className="order-1 lg:order-2 flex items-center justify-center">
          <img
            src={IMG.robotDock}
            alt="Harpalyk LumineX 300 robot vacuum and mop with 3L self-emptying dock"
            fetchpriority="high"
            decoding="async"
            className="w-full max-w-md lg:max-w-xl rounded-3xl shadow-2xl shadow-black/50 hv2-float"
          />
        </Reveal>
      </div>
      <div className="relative pb-8 flex justify-center">
        <ChevronDown className="w-6 h-6 text-white/30 animate-bounce" aria-hidden="true" />
      </div>
    </section>
  );
};

export default LuminexHero;
